/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Use_1_ValueInputs */

const en_svc_rag_use_1_value = /** @type {(inputs: Svc_Rag_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine questions answered from your own help content; the rest goes to your team with the conversation attached.`)
};

const lv_svc_rag_use_1_value = /** @type {(inputs: Svc_Rag_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uz ikdienas jautājumiem sistēma atbild, izmantojot Jūsu palīdzības materiālus; pārējos nodod komandai kopā ar sarunu.`)
};

/**
* | output |
* | --- |
* | "Routine questions answered from your own help content; the rest goes to your team with the conversation attached." |
*
* @param {Svc_Rag_Use_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_use_1_value = /** @type {((inputs?: Svc_Rag_Use_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Use_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_use_1_value(inputs)
	return en_svc_rag_use_1_value(inputs)
});